function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#04895d"
    },
    d: "M100 50c0-27.6-22.4-50-50-50S0 22.4 0 50s22.4 50 50 50 50-22.4 50-50z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#04895d"
    },
    cx: 50,
    cy: 50,
    r: 37.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m61.7 33.8-11.1 6v12.7c2.1-1.1 8.3-4.6 10.4-5.8.4-.2.7-.7.7-1.2V33.8zm-12.4 6.1-11.1-6.2v11.8c0 .5.3.9.7 1.2 2.1 1.2 8.4 4.7 10.4 5.9V39.9zm-10.6-7.4 11.2 6.2 11.3-6.2s-8.7-4.9-10.7-6c-.2-.1-.4-.2-.6-.2-.2 0-.4.1-.6.2-2 1.2-10.6 6-10.6 6zM74.3 54.9l-11.1 6v12.7c2.1-1.1 8.3-4.6 10.4-5.8.4-.2.7-.7.7-1.2V54.9zM61.8 61l-11.1-6.2v11.8c0 .5.3.9.7 1.2 2.1 1.2 8.4 4.7 10.4 5.9V61zm-10.5-7.4 11.2 6.2 11.3-6.2s-8.7-4.9-10.7-6c-.2-.1-.4-.2-.6-.2-.2 0-.4.1-.6.2-2.1 1.2-10.6 6-10.6 6zM49.3 54.9l-11.1 6v12.7c2.1-1.1 8.3-4.6 10.4-5.8.4-.2.7-.7.7-1.2V54.9zM36.9 61l-11.1-6.2v11.8c0 .5.3.9.7 1.2 2.1 1.2 8.4 4.7 10.4 5.9V61zm-10.6-7.4 11.2 6.2 11.3-6.2s-8.7-4.9-10.7-6c-.2-.1-.4-.2-.6-.2-.2 0-.4.1-.6.2-2 1.2-10.6 6-10.6 6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolid);
export default __webpack_public_path__ + "static/media/solid.3860ff8efab9e5e7bf6bf7a7f5be5566.svg";
export { ForwardRef as ReactComponent };